import { render, staticRenderFns } from "./contentCompanyTabbar.vue?vue&type=template&id=571b408a&"
import script from "./contentCompanyTabbar.vue?vue&type=script&lang=js&"
export * from "./contentCompanyTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports